export function isAndroid() {
  return /android/i.test(navigator.userAgent);
}

export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export function isWebView() {
  const rules = [
    // if it says it's a webview, let's go with that
    "WebView",
    // iOS webview will be the same as safari but missing "Safari"
    "(iPhone|iPod|iPad)(?!.*Safari)",
    // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
    // Android KitKat to Lollipop webview will put Version/X.X Chrome/{version}.0.0.0
    "Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})",
    // old chrome android webview agent
    "Linux; U; Android",
  ];

  const regex = new RegExp("(" + rules.join("|") + ")", "ig");

  return "ReactNativeWebView" in window || !!navigator.userAgent.match(regex);
}

/**
 * Checks to see if the current user agent is a modern version
 * of Rex Mobile. Note that old versions of Pocket/Rex Mobile
 * (which don't pass through a custom user agent) won't pass this
 * test
 */
export function isRexCRMMobile() {
  return navigator.userAgent.includes("rex_crm_mobile");
}

export function isRexPMInspectionsApp() {
  return navigator.userAgent.includes("rex_pm_inspections_app");
}

export function isOldVersionPocket() {
  return !isRexCRMMobile() && !isRexPMInspectionsApp() && isWebView();
}
